<template>
  <el-dialog :title="dialogTitle" :visible.sync="editBaselPlanFormVisible" class="dialog_block" width="600" height="500" :close-on-click-modal="false">
    <el-form
      :model="basePlanForm"
      :rules="rules"
      ref="basePlanForm"
      label-width="100px"
      class="demo-dynamic"
    >
      <el-form-item :label="typeName+'日期'" prop="planDate">
        <el-date-picker class="pro_workTime" v-model="basePlanForm.planDate" type="datetime" value-format="yyyy-MM-dd HH:mm"
                        placeholder="选择日期" :picker-options="pickerOptions" @change="changeTableDate">
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="typeName+'内容'" prop="content">
        <textarea v-model="basePlanForm.content" prefix-icon="el-icon-tickets" maxlength="200" class="pro_bz mb_7" style="width:100%;" placeholder="请输入内容"></textarea>
      </el-form-item>
    </el-form>
    <hr>
    <div class="foot_span">
      <el-button class="borderbtn width_80 fz_12" @click="save(1)">保存</el-button>
      <el-button class="blockbtn width_80 fz_12" @click="save(2)" v-if="!source">继续添加</el-button>
      <!-- <el-button @click="close">取 消</el-button> -->
    </div>
  </el-dialog>
</template>

<script>
import { objKeySort } from "@/util/ajaxsign";
export default {
  name: "editBasePlan",
  data() {
    return {
      editBaselPlanFormVisible: false,
      dialogTitle: "添加"+this.typeName+"计划",
      typeId:0,
      basePlanForm: {
        id: "",
        content: "",
        planDate: ""
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= new Date().getTime() - 86400000;
        }
      },
      rules: {
        planDate: [{ required: true, message: "请填写"+this.typeName+"日期", trigger: "blur" }],
        content: [{ required: true, message: "请填写"+this.typeName+"内容", trigger: "blur" }]
      }
    };
  },

  created() {

  },
  filters: {

  },
  methods: {

    //选择开工时间
    changeTableDate(e) {
      let that = this
      console.log("勘察日期：",e);
      that.basePlanForm.planDate = e
    },


    setData(type,data,source) {
      this.editBaselPlanFormVisible = true;
      this.source = source;
      this.cleanForm();
      this.typeId = type;
      let typeName = ""
      switch (type){
        case 1 : typeName = "勘察"; break;
        case 4 : typeName = "验收"; break;
        case 5 : typeName = "回访"; break;
        default: alert("计划类型错误");return;
      }
      this.typeName = typeName;
      if (data) {
        this.basePlanForm = data;
        this.dialogTitle = "修改"+typeName+"计划";
      } else {
        this.dialogTitle = "添加"+typeName+"计划";
        this.cleanForm();
      }
    },
    save(type) {
       let that =this
      that.$refs.basePlanForm.validate(valid => {
        if (valid) {
          that.$emit("setContent", that.typeId,that.basePlanForm);
          if (type == 1) {
            that.close();
          } else {
            that.cleanForm();
          }
        } else {
          return false;
        }
      });
    },

    close() {
      this.editBaselPlanFormVisible = false;
      this.cleanForm();
    },
    cleanForm() {

        if(this.$refs.basePlanForm){
          this.$refs.basePlanForm.clearValidate();

          this.basePlanForm = {
            id: "",
            planDate:"",
            content: "",
            index:-1

          };
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .mb_7{
    margin-bottom: 7px;
  }
  .width_80{
    width: 80px;
    margin-top: 0;
  }
  .el-button{
   padding: 1px 16px;
  }
  .el-upload--picture-card{
    width: 125px;
    height: 125px;
    border-radius:3px;
    border:1px solid rgba(237,239,242,1);
    img{
      width: 100%;
      height: 100%;
      object-fit: contain !important;
    }
  }
  .el-upload-list__item{
    img{
      width: 100%;
      height: 100%;
      object-fit: contain !important;
    }
  }

  .foot_span{
    text-align: right;
    margin-right: 56px;
  }
  hr {
    bottom: 72px;
    border-color: rgba(245, 247, 250, 0.2);
    margin-bottom: 15px;
  }
  .el-dialog__body{
    padding: 0 !important;
  }
  .el-upload-list__item:first-child{
    margin-top: 0 !important;
  }
</style>
